import React from 'react'
import './Footer.css'

export default class Footer extends React.Component {
    render() {
        return (
            <div className='footer-bar'>
                <p><a href="https://icons8.com/icons/set/alternative-herbal-medicine">Alternative Herbal Medicine icon</a> icon by <a href="https://icons8.com">Icons8</a></p>
                <p><a href="https://icons8.com/icons/set/good-quality">Good Quality icon</a> icon by <a href="https://icons8.com">Icons8</a></p>
            </div>
        )
    }
}